export default __webpack_public_path__ + "media/images/avatars/avatar19-87c39d3d9362e335b75119ff8cd190a5.png";